import api from "../../api";
import {
    ADMIN_STATS_REQUEST, ADMIN_STATS_SUCCESS, ADMIN_STATS_FAIL,
    ADMIN_STORES_REQUEST, ADMIN_STORES_SUCCESS, ADMIN_STORES_FAIL,
    ADMIN_STORE_MUTATE_REQUEST, ADMIN_STORE_MUTATE_SUCCESS, ADMIN_STORE_MUTATE_FAIL,
    ADMIN_USERS_REQUEST, ADMIN_USERS_SUCCESS, ADMIN_USERS_FAIL,
    ADMIN_USER_MUTATE_REQUEST, ADMIN_USER_MUTATE_SUCCESS, ADMIN_USER_MUTATE_FAIL,
    PRICE_BOOK_REQUEST, PRICE_BOOK_SUCCESS, PRICE_BOOK_FAIL,
    PRICE_BOOK_MUTATE_REQUEST, PRICE_BOOK_MUTATE_SUCCESS, PRICE_BOOK_MUTATE_FAIL,
    PRICE_BOOK_IMPORT_REQUEST, PRICE_BOOK_IMPORT_SUCCESS, PRICE_BOOK_IMPORT_FAIL,
    WHOLESALE_PRICE_BOOK_REQUEST, WHOLESALE_PRICE_BOOK_SUCCESS, WHOLESALE_PRICE_BOOK_FAIL,
    WHOLESALE_PRICE_BOOK_MUTATE_REQUEST, WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS, WHOLESALE_PRICE_BOOK_MUTATE_FAIL,
    WHOLESALE_PRICE_BOOK_IMPORT_REQUEST, WHOLESALE_PRICE_BOOK_IMPORT_SUCCESS, WHOLESALE_PRICE_BOOK_IMPORT_FAIL,
    ADMIN_CLEAR_ERRORS,
} from "../constants/adminConstants";

export const clearAdminErrors = () => ({ type: ADMIN_CLEAR_ERRORS });

// ─── STATS ────────────────────────────────────────────────────────────────────

export const getAdminStatsAction = () => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_STATS_REQUEST });
        const { data } = await api.get("/api/v1/admin/stats");
        dispatch({ type: ADMIN_STATS_SUCCESS, payload: data });
    } catch (err) {
        dispatch({ type: ADMIN_STATS_FAIL, payload: err.response?.data?.message || err.message });
    }
};

// ─── STORES ───────────────────────────────────────────────────────────────────

export const getAllStoresAction = () => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_STORES_REQUEST });
        const { data } = await api.get("/api/v1/admin/stores");
        dispatch({ type: ADMIN_STORES_SUCCESS, payload: data.stores });
    } catch (err) {
        dispatch({ type: ADMIN_STORES_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const createStoreAction = (storeData) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_STORE_MUTATE_REQUEST });
        const { data } = await api.post("/api/v1/admin/stores", storeData);
        dispatch({ type: ADMIN_STORE_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: ADMIN_STORE_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const updateStoreAction = (id, storeData) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_STORE_MUTATE_REQUEST });
        const { data } = await api.put(`/api/v1/admin/stores/${id}`, storeData);
        dispatch({ type: ADMIN_STORE_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: ADMIN_STORE_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const deleteStoreAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_STORE_MUTATE_REQUEST });
        const { data } = await api.delete(`/api/v1/admin/stores/${id}`);
        dispatch({ type: ADMIN_STORE_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: ADMIN_STORE_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

// ─── USERS ────────────────────────────────────────────────────────────────────

export const getAllStoreUsersAction = (storeId) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_USERS_REQUEST });
        const params = storeId ? `?storeId=${storeId}` : "";
        const { data } = await api.get(`/api/v1/admin/users${params}`);
        dispatch({ type: ADMIN_USERS_SUCCESS, payload: data.users });
    } catch (err) {
        dispatch({ type: ADMIN_USERS_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const createStoreUserAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_USER_MUTATE_REQUEST });
        const { data } = await api.post("/api/v1/admin/users", userData);
        dispatch({ type: ADMIN_USER_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: ADMIN_USER_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const updateStoreUserAction = (id, userData) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_USER_MUTATE_REQUEST });
        const { data } = await api.put(`/api/v1/admin/users/${id}`, userData);
        dispatch({ type: ADMIN_USER_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: ADMIN_USER_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const deleteStoreUserAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_USER_MUTATE_REQUEST });
        const { data } = await api.delete(`/api/v1/admin/users/${id}`);
        dispatch({ type: ADMIN_USER_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: ADMIN_USER_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

// ─── PRICE BOOK ───────────────────────────────────────────────────────────────

export const getPriceBookAction = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: PRICE_BOOK_REQUEST });
        const query = new URLSearchParams(params).toString();
        const { data } = await api.get(`/api/v1/admin/price-book?${query}`);
        dispatch({ type: PRICE_BOOK_SUCCESS, payload: data });
    } catch (err) {
        dispatch({ type: PRICE_BOOK_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const createPriceBookItemAction = (item) => async (dispatch) => {
    try {
        dispatch({ type: PRICE_BOOK_MUTATE_REQUEST });
        const { data } = await api.post("/api/v1/admin/price-book", item);
        dispatch({ type: PRICE_BOOK_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: PRICE_BOOK_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const updatePriceBookItemAction = (id, item) => async (dispatch) => {
    try {
        dispatch({ type: PRICE_BOOK_MUTATE_REQUEST });
        const { data } = await api.put(`/api/v1/admin/price-book/${id}`, item);
        dispatch({ type: PRICE_BOOK_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: PRICE_BOOK_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const deletePriceBookItemAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: PRICE_BOOK_MUTATE_REQUEST });
        const { data } = await api.delete(`/api/v1/admin/price-book/${id}`);
        dispatch({ type: PRICE_BOOK_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: PRICE_BOOK_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const importPriceBookAction = (items) => async (dispatch) => {
    try {
        dispatch({ type: PRICE_BOOK_IMPORT_REQUEST });
        const CHUNK = 100;
        let totalInserted = 0;
        let totalSkipped = 0;
        for (let i = 0; i < items.length; i += CHUNK) {
            const chunk = items.slice(i, i + CHUNK);
            const { data } = await api.post("/api/v1/admin/price-book/import", { items: chunk });
            totalInserted += data.inserted || 0;
            totalSkipped += data.skipped || 0;
        }
        dispatch({ type: PRICE_BOOK_IMPORT_SUCCESS, payload: { inserted: totalInserted, skipped: totalSkipped } });
    } catch (err) {
        dispatch({ type: PRICE_BOOK_IMPORT_FAIL, payload: err.response?.data?.message || err.message });
    }
};

// ─── WHOLESALE PRICE BOOK ─────────────────────────────────────────────────────

export const getWholesalePriceBookAction = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: WHOLESALE_PRICE_BOOK_REQUEST });
        const query = new URLSearchParams(params).toString();
        const { data } = await api.get(`/api/v1/admin/wholesale-price-book?${query}`);
        dispatch({ type: WHOLESALE_PRICE_BOOK_SUCCESS, payload: data });
    } catch (err) {
        dispatch({ type: WHOLESALE_PRICE_BOOK_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const createWholesaleItemAction = (item) => async (dispatch) => {
    try {
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_REQUEST });
        const { data } = await api.post("/api/v1/admin/wholesale-price-book", item);
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const updateWholesaleItemAction = (id, item) => async (dispatch) => {
    try {
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_REQUEST });
        const { data } = await api.put(`/api/v1/admin/wholesale-price-book/${id}`, item);
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const deleteWholesaleItemAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_REQUEST });
        const { data } = await api.delete(`/api/v1/admin/wholesale-price-book/${id}`);
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_SUCCESS, payload: data.message });
    } catch (err) {
        dispatch({ type: WHOLESALE_PRICE_BOOK_MUTATE_FAIL, payload: err.response?.data?.message || err.message });
    }
};

export const importWholesalePriceBookAction = (items) => async (dispatch) => {
    try {
        dispatch({ type: WHOLESALE_PRICE_BOOK_IMPORT_REQUEST });
        const CHUNK = 100;
        let totalInserted = 0;
        let totalSkipped = 0;
        for (let i = 0; i < items.length; i += CHUNK) {
            const chunk = items.slice(i, i + CHUNK);
            const { data } = await api.post("/api/v1/admin/wholesale-price-book/import", { items: chunk });
            totalInserted += data.inserted || 0;
            totalSkipped += data.skipped || 0;
        }
        dispatch({
            type: WHOLESALE_PRICE_BOOK_IMPORT_SUCCESS,
            payload: { inserted: totalInserted, skipped: totalSkipped },
        });
    } catch (err) {
        dispatch({
            type: WHOLESALE_PRICE_BOOK_IMPORT_FAIL,
            payload: err.response?.data?.message || err.message,
        });
    }
};
